// extracted by mini-css-extract-plugin
export default {"base":"CheckBox_base__Lq0UJ","disabled":"CheckBox_disabled__1yN88"};